import { replace } from 'connected-react-router';
import _get from 'lodash/get';

import { showTransparentLoader, hideLoader, showSnackbar } from 'containers/store';
import ApiManager from 'utils/ApiManager';
import snackbarMessages from 'utils/snackbarMessages';
import isBadRequest from 'utils/isBadRequest';

export const initialState = {
  isLoadedPage: false,
  initialValues: {
    login: '',
  },
};

export const actionTypes = {
  LOAD_PAGE_SUCCESS: 'FORGOT_PASSWORD/LOAD_PAGE_SUCCESS',
  CLEAR_STORE: 'FORGOT_PASSWORD/CLEAR_STORE',
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PAGE_SUCCESS: {
      return {
        ...state,
        isLoadedPage: true,
        initialValues: {
          ...state.initialValues,
          login: action.login,
        },
      };
    }

    case actionTypes.CLEAR_STORE: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
};

const loadPageSuccess = (login) => ({
  type: actionTypes.LOAD_PAGE_SUCCESS,
  login,
});

export const clearStore = () => ({
  type: actionTypes.CLEAR_STORE,
});

export const onSendClick = (values) => (dispatch) => {
  dispatch(showTransparentLoader());

  const requestBody = {
    data: {
      email: values.login,
    },
  };

  ApiManager.request('post', dispatch, 'forgot_password', requestBody).then(() => {
    dispatch(hideLoader());
    dispatch(replace('/login', { showSnackbar: true, snackbarMessage: snackbarMessages.succesfullyResetedPassword }));
  }).catch((error) => {
    if (isBadRequest(error)) {
      dispatch(showSnackbar(snackbarMessages.wrongData));
    } else {
      dispatch(showSnackbar(snackbarMessages.globalError));
    }

    dispatch(hideLoader());
  });
};

export const loadPageData = (routeState) => (dispatch) => {
  const login = _get(routeState, 'login', '');

  dispatch(loadPageSuccess(login));
};
